
import { rutFilter } from 'vue-dni';

export default function rut(value, formatted = true) {
  if (formatted) {
    return rutFilter(value);
  }

  return rutFilter(value).replaceAll('.', '');
}
